var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBackFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_4142)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 5a1 1 0 011 1v12a1 1 0 01-1 1H6l-.103-.005A1 1 0 015 18V6a1 1 0 011-1h17zm-.5 10.041a3.003 3.003 0 00-2.458 2.459H22.5v-2.459zM6.5 17.5h2.458A3.003 3.003 0 006.5 15.041V17.5zm8-9.5a4 4 0 100 8 4 4 0 000-8zm-8 .958a3.002 3.002 0 002.41-2.226l.048-.232H6.5v2.458zM20.042 6.5A3.002 3.002 0 0022.5 8.958V6.5h-2.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.126 8.584a.75.75 0 011.248.832l-1.63 2.445a.25.25 0 000 .278l1.63 2.445.04.066a.75.75 0 01-1.242.827l-.046-.061-1.63-2.445a1.75 1.75 0 010-1.942l1.63-2.445z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_4142"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgMoneyBackFilled.displayName = 'MoneyBackFilled';
export default SvgMoneyBackFilled;